export default __webpack_public_path__ + "static/media/IMG4511.014a2f22.jpg";